// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const reautomatePayloadSchema = z.object({
  annotations: z.array(urlSchema),
  ifModified: z
    .union([z.literal('skip'), z.literal('tryToConfirm')])
    .optional(),
});

export const reautomateResponseSchema = z.object({
  annotations: z.array(urlSchema),
});
